import $ from 'jquery';
import Component from '../models/Component';


export default class ScrollSmootherPage extends Component {
    constructor(element, context) {
        super(element, context);
    
        const viedoTutorial = this.element.find("#video-tutorial");
        const previewImage = this.element.find("#preview-image")
        const playButton = this.element.find("#play-button")
        const videoOverlay = this.element.find("#video-overlay")

        if (viedoTutorial && previewImage && playButton && videoOverlay) {
            
            playButton.on('click', function(e) {
                e.stopPropagation();
                previewImage.css('opacity', '0');
                videoOverlay.css('opacity', '0');
                videoOverlay.css('cursor', 'pointer');
                videoOverlay.css('z-index', '5');
                playButton.css('opacity', '0');
                setTimeout(() => {
                    viedoTutorial[0].play();
                }, 200);
            });

            videoOverlay.on('click', function() {
                if (!viedoTutorial[0].paused) {
                  viedoTutorial[0].pause();
                  videoOverlay.css('opacity', '0.2');
                  videoOverlay.css('cursor', 'auto');
                  videoOverlay.css('z-index', '3');
                  playButton.css('opacity', '1');
                }
            });


        }
      
    }
}